module.exports = __webpack_public_path__ + "assets/img/8ab6-ac.svg";